<!-- eslint-disable vue/multi-word-component-names -->
<script>
import NotificationHelper from '@/Helpers/800/notification/notification.helper';
import NotificationMixin from '@/Mixins/800/notification/notification.mixin';
import SharedMixin from '@/Mixins/Shared';
import UserNotificationMixin from '@/Mixins/800/userNotification.mixin';
import AppPageContainer from '@/components/app/PageContainer.vue';
import AppWrapText from '@/components/app/wrapText.vue';
import AppBox from '@/components/app/box.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import StatusSwitcher from '@/components/BaseInformation/ChiefComplaint/StatusSwitcher.vue';
export default {
  title: 'اعلانات',
  inject: ['load'],
  components: {
    AppPageContainer,
    AppWrapText,
    ConfirmDialog,
    AppBox,
    StatusSwitcher,
  },
  mixins: [NotificationHelper, NotificationMixin, SharedMixin, UserNotificationMixin],
  created() {
    this.$root.$refs.notificationView = this;
    this.$mobileSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
    this.$mainSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
  },
  beforeDestroy() {
    this.$mainSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);

    delete this.$root.$refs.notificationView;
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      const userId = this.$store.state.userModule.userId;
      this.getAllActiveNotifications({
        userId,
      });
    },
    fNotifyOutOfService: function (data) {
      switch (data?.type) {
        case 1:
          this.showTostMessage2(data?.text, 'ambulance107s', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        case 2:
          this.showTostMessage2(data?.text, '', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        default:
          break;
      }
      this.onGetAllUserNotificationOnSignal();
    },
  },
};
</script>
<template>
  <app-page-container title="اعلانات">
    <template v-slot:header>
      <v-col cols="4" class="">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3 mr-n16"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-col cols="2" class="text-left">
        <v-btn rounded color="darkColor" dark @click="addNewNotification()" class="mt-3 normal-letter-spacing ml-3">
          <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
          افزودن اعلان
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <section>
        <v-row no-gutters class="background-main mx-2">
          <v-col cols="12">
            <v-card elevation="0" class="body-card card-width">
              <v-row no-gutters>
                <v-col cols="12">
                  <template>
                    <v-data-table id="mission_table" :headers="tableHeaders" :items="allNotifications"
                      :items-per-page="allNotifications.length" fixed-header height="69vh" item-key="id"
                      :hide-default-footer="true" class="elevation-0 notification-table" dense :search="searchTitle">
                      <template v-slot:[`item.user`]="{ item }">
                        <app-wrap-text :text="item?.user ?? ''" />
                      </template>
                      <template v-slot:[`item.status`]="{ item }">
                        <v-row @click="wantToChangeNotificationStatus(item?.status, item?.id)" justify="center">
                          <status-switcher :value="item?.status" />
                        </v-row>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer" v-bind="attrs" v-on="on"
                              @click="showNotificationDetail(item.id)">
                              mdi-information mdi-24px
                            </v-icon>
                          </template>
                          <span>جزئیات</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer" v-bind="attrs" v-on="on"
                              @click="editNotification(item?.id)">
                              mdi-pencil mdi-24px
                            </v-icon>
                          </template>
                          <span>ویرایش</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
                <v-col>
                  <!-- <app-pagination
                    v-model="pagination"
                    :total-pages="totalPages"
                  /> -->
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </section>
    </template>
    <template v-slot:append>
      <section>
        <confirm-dialog ref="confirm">
          <v-row slot="action" no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
              style="color: white" @click="onConfirmation()" :disabled="disabelConfirm">
              بله
            </v-btn>
            <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
              @click="hideConfirmModal()">
              خیر
            </v-btn>
          </v-row>
        </confirm-dialog>
        <v-dialog width="450" v-model="showDetailModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-4">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-information</v-icon>
                  <span class="modal-title-text mr-2">جزییات</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text>
              <v-row justify="center" class="my-4 px-2">
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="3" class="primary-color">اطلاعات اصلی</v-col>
                    <v-col class="px-0 pt-2">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <app-box>
                    <v-row class="align-start">
                      <v-col cols="3" class="text-sm text-semibold">توضیحات</v-col>
                      <v-col cols="9">
                        <p class="text-sm mb-0">
                          {{ notification?.description }}
                        </p>
                      </v-col>
                    </v-row>
                  </app-box>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <app-box>
                    <v-row class="align-start">
                      <v-col cols="2" class="text-sm text-semibold">تاریخ</v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="6" class="text-left">{{ notification?.expirationDate }}</v-col>
                    </v-row>
                  </app-box>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="3" class="primary-color">کدهای انتخابی</v-col>
                    <v-col class="px-0 pt-2">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <app-box>
                    <v-chip-group column>
                      <v-chip v-for="{ id, code } in notification?.noticePhones" :key="id" label dark
                        class="darkColor text--white" :ripple="false">
                        {{ code }}
                      </v-chip>
                    </v-chip-group>
                  </app-box>
                </v-col>
              </v-row>
            </v-card-text>
            <!-- <v-divider></v-divider> -->
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-col cols="5">
                <v-btn block outlined rounded color="#0D296E" @click="closeDetailModal()">
                  بستن
                </v-btn>
              </v-col>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </section>
    </template>
  </app-page-container>
</template>
<style lang="scss">
.notification-table {
  & {

    td,
    th {
      padding: 1rem 0.25rem !important;
    }

    th {
      padding-bottom: 0 !important;
    }
  }
}
</style>
